import { render } from "./MealReservation.vue?vue&type=template&id=c8d120f4&scoped=true"
import script from "./MealReservation.vue?vue&type=script&lang=js"
export * from "./MealReservation.vue?vue&type=script&lang=js"

import "./MealReservation.vue?vue&type=style&index=0&id=c8d120f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8d120f4"]])

export default __exports__